import { AnalyticsHeader } from "../../components";
import styles from "./Analyticsv2.module.css";
import MainBottomRight from "../../components/analytics/mainBottomRight/MainBottomRight";
import MainTopRight from "../../components/analytics/mainTopRight/MainTopRight";
import MainMiddleRIght from "../../components/analytics/mainMiddleRight/MainMiddleRight";
import DashboardPositions from "../../components/analytics/DashBoardPosition/DashboardPositions";
import { TempPositions } from "../../data/positions";
import PositionCard from "../../components/analytics/positionCard/PositionCard";
// import PositionCardv2 from "../../components/analytics/positionCardv2/PositionCardv2";
import RecentTrades from "../../components/analytics/recentTrades/RecentTrades";
import PositionCardv2 from "../../components/analytics/positionCardv2/PositionCardv2";
import Divider from "../../components/misc/Divider/Divider";
const Analyticsv2 = () => {
  const LiquidityPositions = (
    <div>
      <div className={styles.position_header}>
        <div className={styles.left_side}>
          <span>Pair</span>
          <span>Address</span>
          <span>Range</span>
          <span>APY</span>
        </div>
        <div className={styles.right_side}></div>
      </div>
      <Divider/>
      <div className={styles.position_container_scroll}>
        {TempPositions.map((position) => (
          // <PositionCard posDetail={position.posDetail} key={position.positionHash} />
          <PositionCardv2
            posHash={position.posHash}
            posDetail={position.posDetail}
            key={position.positionHash}
          />
        ))}
      </div>
    </div>
  );

  return (
    <div className={styles.analytics_window}>
      <div className={styles.analytics_container}>
        <AnalyticsHeader />
        <section className={styles.wallet_balance_container}>
          <section>
            <span className={styles.section_title}>Wallet Balance</span>
            <MainBottomRight />
          </section>
          <section>
            <span className={styles.section_title}>Echange Balance</span>
            <MainMiddleRIght />
          </section>
        </section>
        <span className={styles.section_title}>Liquidity Positions</span>
        <section className={styles.liquidity_positions}>
          <div className={styles.liquidity_positions_content}>
            {LiquidityPositions}
          </div>
        </section>
        <span className={styles.section_title}>Recent Trades</span>
        <section className={styles.recent_trades_container}>
          <RecentTrades />
        </section>
      </div>
    </div>
  );
};

export default Analyticsv2;
